import { useState, useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import { Autoplay, EffectFade } from "swiper/modules";

const slides = [
  {
    title: "MerryColor",
    subtitle: "El arte de florecer",
    image: require("../../assets/img/main-bg.jpg"),
  },
  {
    title: "Belleza Natural",
    subtitle: "Colores que inspiran",
    image: require("../../assets/img/nails1.jpg"),
  },
];

export const Banner = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Trigger entrance animation
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "220px", sm: "280px", md: "340px" },
        overflow: "visible",
      }}
    >
      {/* Background Images — no parallax, just clean fade transitions */}
      <Swiper
        modules={[Autoplay, EffectFade]}
        effect="fade"
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop={true}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        style={{ width: "100%", height: "100%", position: "absolute", top: 0 }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <Box
              sx={{
                backgroundImage: `url(${slide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center 30%",
                width: "100%",
                height: "100%",
                position: "absolute",
                top: 0,
                left: 0,
                transition: "transform 8s ease-out",
                transform: loaded ? "scale(1.05)" : "scale(1)",
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Gradient overlay — refined with better blending */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "linear-gradient(180deg, rgba(128,31,86,0.05) 0%, rgba(128,31,86,0.12) 50%, rgba(255,255,255,0.5) 85%, rgba(255,255,255,0.95) 100%)",
          zIndex: 2,
          pointerEvents: "none",
        }}
      />

      {/* Bottom blur fade that bleeds into the catalog below */}
      <Box
        sx={{
          position: "absolute",
          bottom: -30,
          left: 0,
          right: 0,
          height: "80px",
          background:
            "linear-gradient(180deg, transparent 0%, rgba(255,255,255,0.85) 50%, #fff 100%)",
          backdropFilter: "blur(6px)",
          WebkitBackdropFilter: "blur(6px)",
          zIndex: 3,
          pointerEvents: "none",
        }}
      />

      {/* Text Content — with entrance animation */}
      <Box
        sx={{
          position: "absolute",
          top: "42%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          zIndex: 10,
          width: "90%",
          maxWidth: "500px",
          opacity: loaded ? 1 : 0,
          transition: "all 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.3s",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "1.8rem", sm: "2.4rem", md: "3rem" },
            fontWeight: 800,
            color: "#801F56",
            letterSpacing: "-0.02em",
            lineHeight: 1,
            mb: 0.5,
            fontFamily: "'Playfair Display', serif",
            textShadow: "0 2px 20px rgba(255,255,255,0.6)",
          }}
        >
          {slides[activeIndex].title}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "0.9rem", sm: "1rem", md: "1.2rem" },
            fontWeight: 500,
            color: "#801F56",
            opacity: 0.85,
            fontFamily: "'Playfair Display', serif",
            letterSpacing: "0.5px",
          }}
        >
          {slides[activeIndex].subtitle}
        </Typography>
      </Box>

      {/* Slide Indicators — minimal pill style */}
      <Box
        sx={{
          position: "absolute",
          bottom: 24,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: 0.8,
          zIndex: 10,
        }}
      >
        {slides.map((_, index) => (
          <Box
            key={index}
            sx={{
              width: activeIndex === index ? 24 : 6,
              height: 6,
              borderRadius: 3,
              backgroundColor:
                activeIndex === index
                  ? "#801F56"
                  : "rgba(128, 31, 86, 0.35)",
              transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Banner;
